// La carte cosmique : la page (V4CosmicMap), le ciel d'une marque, et le ciel
// du dossier (V4CielDossier, ciel-dossier.ts).
export default {
  titre: 'Carte cosmique',
  pleinEcran: 'Plein écran',
  aValider: 'à valider',
  dashboard: 'Dashboard',
  gererCluster: 'Gérer le cluster',
  aucuneMarque: "Ce dossier ne contient encore aucune marque : il n'y a rien à poser sur le ciel.",

  // ── La page et le ciel d'une marque ───────────────────────────────────────
  page: {
    sousTitreDossier: "{dossier} · ses marques sur un seul ciel, et ce qu'elles partagent",
    leDossier: 'Le dossier',
    sousTitreMarque: "Recouvrements d'audience · espace libre · positions par proximité, pas par catégorie",
    construction: "Construction du ciel d'audience…",
    sansDossier: "La carte cosmique se lit par dossier : choisissez-en un dans la barre de gauche. Elle pose ses marques sur un seul ciel, avec ce qu'elles partagent.",
    mesDossiers: 'Mes dossiers',
    erreurMarques: "La liste des marques n'a pas pu se charger : la carte ne sait pas ce que contient le dossier.",
    onglets: 'Les ciels du dossier',
    ongletRecouvrementAide: "Les marques du dossier sur un seul ciel, et ce qu'elles partagent",
    recouvrement: 'Recouvrement',
    cielDe: 'Le ciel de {nom}',
    lecture: "Nodes = marques · arêtes = recouvrement d'audience calculé sur les personas. Cliquez un système solaire pour entrer dedans, un node pour le détail.",
    sansGalaxie: 'Sélectionnez une galaxie avec des sub-brands pour afficher la carte.',
    couvertureAide: "Couverture estimée du territoire par cette marque (lexicale, pas un recouvrement d'audience)",
    revenirVueGalaxie: 'Revenir à la vue galaxie',
    entrerSysteme: 'Entrer dans ce système',
    ouvrirBriefAide: 'Ouvrir le brief de ce territoire',
    espaceLibre: 'Espace libre',
    cielAudience: "Ciel d'audience · {date}",
    recouvrementMax: 'Recouvrement max {n} % ·',
    force: 'force {n}/100 ·',
    overlaps: 'ⓘ overlaps personas',
    vueEnsemble: "Vue d'ensemble",
    entrerDansSysteme: 'Entrer dans le système',
  },
  niveau: {
    galaxy: 'Galaxie',
    solar_system: 'Système solaire',
    planet: 'Planète',
  },
  mode: {
    nebula: 'Nébuleuse',
    audiences: 'Audiences',
    territories: 'Territoires',
    exploded: 'Éclatée',
  },
  legende: {
    galaxie: 'Galaxie',
    systeme: 'Système solaire',
    planete: 'Planète',
    audience: 'Audience (persona)',
    territoire: 'Territoire (segment)',
    espaceLibre: 'Espace libre (carte)',
    epaisseur: 'épaisseur = recouvrement',
  },
  // La légende sous le ciel d'une marque.
  entete: {
    hierarchie: '{nom} - hiérarchie dépliée.',
    systeme: 'Système {nom}.',
    audiences: 'Les audiences mesurées de {nom}.',
    territoires: 'Les territoires de {nom}.',
    espaceLibre: "L'espace « {label} » est libre.",
    ciel: "Le ciel d'audience de {nom}.",
  },
  // Ce que dit le panneau d'un corps du ciel.
  corps: {
    sourceOverlaps: 'Recouvrements calculés sur les audiences les plus récentes de chaque marque',
    dansSonCiel: 'corps dans son ciel',
    mentionne: "de l'audience de {nom} le mentionne",
    estime: "recouvrement d'audience estimé avec {nom}",
    avec: 'recouvrement avec {nom}',
    concurrent: 'Concurrent',
    concurrentSub: 'concurrent du cluster · score estimé',
    scoreEstime: 'score estimé',
    score: 'score',
    concurrentInsight: 'Concurrent identifié dans le cluster de {nom} - pas encore lié à une marque Orion, donc pas de recouvrement mesurable.',
    positionInsight: 'Position dans la hiérarchie de {nom}. Recouvrements calculés sur les audiences.',
    estimation: 'estimation',
    overlapsPersonas: 'overlaps personas',
    concurrentAide: 'Score et recouvrement estimés sur la notoriété du concurrent - à valider. Un audit profond mesurera le recouvrement réel.',
    ouvrirChaine: 'Ouvrir la chaîne',
    territoireKind: 'Territoire · segment',
    territoireSub: "segment de marché · détecté à l'audit",
    corpsSurTerritoire: 'corps sur ce territoire',
    partDe: 'part de {nom}',
    occupePar: 'Occupé par : {liste}.',
    aucunCorps: 'Aucun corps du ciel rattaché - auditez les marques pour peupler ce territoire.',
    territoiresAudit: 'territoires (audit)',
    territoiresAide: "Segments détectés automatiquement à l'audit et partagés entre marques. La part est le poids du territoire dans l'identité mesurée de la marque.",
    gererTerritoires: 'Gérer les territoires',
    audienceKind: 'Audience · persona',
    persona: 'persona',
    partAudience: "part d'audience",
    confiance: 'confiance',
    tension: 'Tension : {texte}',
    personasV2: 'personas V2',
    personaAideGalaxie: "Persona mesurée sur le dernier audit de la galaxie - la part est la taille estimée du segment dans l'audience.",
    personaAide: "Persona mesurée sur le dernier audit - la part est la taille estimée du segment dans l'audience.",
    parlerPersona: 'Parler à cette persona',
    vousEtesIci: 'vous êtes ici',
    partMarque: 'part de la marque',
    corpsDessus: 'corps du ciel dessus',
    partTerritoire: "Part du territoire « {nom} » dans l'identité mesurée de {marque}.",
    revenirGalaxie: 'Revenir à la galaxie',
  },

  // ── Le ciel du dossier ────────────────────────────────────────────────────
  ciel: {
    erreur: 'Carte du dossier illisible',
    marque: 'Marque',
    territoire: 'Territoire',
    concurrent: 'Concurrent',
    persona: 'Persona',
    nb: {
      territoire: '{n} territoire | {n} territoire | {n} territoires',
      concurrent: '{n} concurrent | {n} concurrent | {n} concurrents',
      compte: '{n} compte | {n} compte | {n} comptes',
      dimension: '{n} dimension | {n} dimension | {n} dimensions',
      marque: '{n} marque | {n} marque | {n} marques',
      persona: '{n} persona | {n} persona | {n} personas',
      sousMarque: '{n} sous-marque | {n} sous-marque | {n} sous-marques',
      signal: '{n} signal | {n} signal | {n} signaux',
    },
    genre: {
      vertical: 'verticale',
      geographic: 'géographique',
    },
    relation: {
      direct: 'concurrent direct',
      aspirational: 'modèle visé',
      autre: 'concurrent',
    },
    rienMesurable: 'rien de mesurable',
    rienEnCommun: 'rien en commun',
    manque: '{marque} : {raison}',
    separateur: ' ; ',
    et: 'et',
    etDe: 'et de',
    titre: {
      partagent: '{a} et {b} partagent {liste}.',
      concept: '{a} et {b} : {concept}, sur deux marchés.',
      memeCiel: '{a} et {b}, sur un même ciel.',
      toutes: 'Les {n} marques de {dossier}, sur un même ciel.',
    },
    enCommunN: '({n} en commun)',
    mesureAide: 'Communautés : estimation, calculée sur les personas de chaque marque (mêmes mots, mêmes plateformes). Territoires, concurrents et comptes : mesurés sur les rattachements, les clusters validés et les signaux. Une dimension qui ne se mesure pas est dite, jamais comptée zéro.',
    intro: "Les marques du dossier sur un seul ciel. Ce qu'elles partagent se pose entre elles ; l'arête qui les relie porte ce qui se mesure de l'une à l'autre. Cliquez un corps pour le détail, une marque pour ouvrir son ciel.",
    construction: 'Construction du ciel du dossier…',
    erreurConstruction: "La carte du dossier n'a pas pu se construire : {erreur}",
    pairesAide: 'Ce qui se mesure entre ces deux marques : cliquez pour le détail',
    memeVerticale: 'même verticale · {concept}',
    cielDuDossier: 'Ciel du dossier · {date}',
    commentMesure: "ⓘ comment c'est mesuré",
    recouvrement: 'Recouvrement',
    dimensionsEnCommun: '{dimensions} en commun',
    rienDeMesure: 'rien en commun de mesuré',
    nonMesurables: '{n} non mesurable | {n} non mesurable | {n} non mesurables',
    communautes: 'Communautés',
    estimation: 'estimation',
    estimationAide: "Calculé sur les personas : une proximité d'univers, pas des individus comptés",
    recouvrementPersonas: 'Recouvrement de leurs personas ({a} et {b}), la même formule que la carte de chaque marque.',
    langues: 'Personas en {a} et en {b} : la comparaison porte sur les mots, elle sous-estime la proximité.',
    faitLeChiffre: 'Ce qui fait le chiffre',
    mot: '« {mot} »',
    memesMots: 'mêmes mots : {mots}',
    memesPlateformes: 'mêmes plateformes : {liste}',
    seulementPlateformes: 'seulement les mêmes plateformes : {liste}',
    aucunMot: 'Aucun mot ni aucune plateforme en commun entre leurs personas.',
    nonMesurable: 'Non mesurable. {raisons}.',
    territoires: 'Territoires',
    mesure: 'mesure',
    territoiresCommun: 'En commun, sur {a} et {b} :',
    aucunTerritoire: 'Aucun territoire en commun (sur {a} et {b}).',
    verticaleDeuxMarches: 'Même verticale sur deux marchés :',
    verticalePaire: '« {a} » et « {b} ».',
    memeUnivers: "Le même univers, deux populations : ce n'est pas un recouvrement d'audience.",
    concurrents: 'Concurrents',
    concurrentsCommun: 'En commun, sur {a} et {b} validés :',
    aucunConcurrent: 'Aucun concurrent en commun (sur {a} et {b} validés).',
    cite: '{de} cite {vers} parmi ses concurrents validés.',
    comptesEnCommun: 'Comptes en commun',
    memesComptes: 'Les mêmes comptes, qui parlent des deux marques dans des contenus distincts, sur {a} et {b} comptes identifiables.',
    signauxPaire: '{a} et {b} signaux',
    createur: 'créateur',
    etAutres: 'et {n} autres.',
    memeContenu: "{comptes} en commun par un même contenu, collecté pour les deux marques ({liste}) : c'est la collecte qui se recoupe, pas l'audience. Non compté.",
    echantillon: 'Lu sur les signaux les plus récents de chaque marque : le compte est un minimum.',
    cielDe: 'Ciel de {nom}',
    marqueDuDossier: 'Marque du dossier',
    marqueMin: 'marque',
    score: 'score',
    territoiresConcurrents: 'territoires · concurrents',
    personasJamais: 'Personas jamais calculées',
    comptesIdentifiables: '{signaux} de comptes identifiables',
    plusRecents: '(les plus récents)',
    dansSonCiel: '{sousMarques} dans son ciel',
    sesRecouvrements: 'Ses recouvrements dans le dossier',
    ouvrirSonCiel: 'Ouvrir son ciel',
    principal: 'principal du dossier',
    ouvert: 'ouvert au dossier',
    ouvertSansMarque: 'Ouvert au dossier, porté par aucune de ses marques.',
    enCommunEntre: 'En commun entre {liste}.',
    portePar: 'Porté par {nom} seulement.',
    porteSous: '{nom} le porte par ses sous-marques.',
    porteSousDirect: '{nom} le porte par ses sous-marques, et directement.',
    porteUne: '{nom} le porte par une sous-marque.',
    porteUneDirect: '{nom} le porte par une sous-marque, et directement.',
    jumelle: 'Même verticale que « {nom} » : le même univers sur un autre marché, deux populations distinctes.',
    jumellePorteurs: 'Même verticale que « {nom} », porté par {porteurs} : le même univers sur un autre marché, deux populations distinctes.',
    territoiresDossierAide: "Détecté à l'audit ou posé à la main sur une marque du dossier. Le client voit le terrain de ses territoires, jamais leur synthèse.",
    territoiresDossier: 'ⓘ territoires du dossier',
    suiviOrion: 'suivi dans Orion',
    externe: 'externe',
    concurrentDe: 'Concurrent de {liste} : ils le partagent.',
    valideDans: 'Validé dans le cluster de {nom} seulement.',
    recouvrementEstime: 'recouvrement estimé par le modèle : {n} %',
    pct: '{n} %',
    sousMarque: 'Sous-marque',
    dansLeCielDe: 'Dans le ciel de {nom} : ses recouvrements se lisent sur la carte de celle-ci.',
    ouvrirLeCielDe: 'Ouvrir le ciel de {nom}',
    leDossier: 'Le dossier',
    marqueAMarque: 'Recouvrements, marque à marque',
    uneSeule: "Une seule marque : il n'y a pas de recouvrement à mesurer.",
    legende: {
      enCommun: 'en commun',
      entreDeux: 'ce qui se mesure entre deux marques',
      verticale: 'même verticale, autre marché',
      mesureEstime: 'ⓘ mesuré, estimé',
    },
  },
}
